import type { IFixture } from "core-integration/src/store/fixtures/types";
import type { TeamSavedPromotion } from "./types";

export interface PickedModal {
  index: number;
  promotion: TeamSavedPromotion;
}

export const getLastKickoffTime = (fixtures: IFixture[]) =>
  fixtures.reduce<number | null>((latest, fixture) => {
    if (!fixture.kickoff_time) return latest;
    const time = new Date(fixture.kickoff_time).getTime();
    return latest === null || time > latest ? time : latest;
  }, null);

// First eligible modal from startIndex onwards, wrapping round to the start
export const pickModal = (
  modals: TeamSavedPromotion[],
  isEligible: (promotion: TeamSavedPromotion) => boolean,
  startIndex: number,
): PickedModal | null => {
  for (let i = 0; i < modals.length; i++) {
    const index = (startIndex + i) % modals.length;
    const promotion = modals[index];
    if (isEligible(promotion)) return { index, promotion };
  }
  return null;
};

const nextIndexStorageKey = "teamSavedModalNextIndex";

export const getStoredNextIndex = () => {
  const index = Number(localStorage.getItem(nextIndexStorageKey));
  return Number.isInteger(index) && index >= 0 ? index : 0;
};

export const storeNextIndex = (index: number) =>
  localStorage.setItem(nextIndexStorageKey, String(index));
